import React from 'react';
import Navbar from '../Menu/Navbar';
import { useCrudPageStateContext } from '@/context/CrudPageContext';
import { MailIcon, PlusIcon } from 'lucide-react';
import { useEmployeesPageContext } from './contexts/EmployeesPageContext';
import { useTranslation } from 'react-i18next';

export function EmployeesPageHeader() {
  const { t } = useTranslation();
  const { setOpenCreateDialog } = useCrudPageStateContext();
  const { setOpenInviteDialog } = useEmployeesPageContext();

  return (
    <Navbar
      start={<p className="hidden lg:block p-4">{t('menu.employees')}</p>}
      end={
        <div className="p-4 w-full flex flex-row space-x-3 justify-end">
          <div
            className="btn btn-primary text-white hover:cursor-pointer flex items-center"
            onClick={() => setOpenCreateDialog(true)}
          >
            <PlusIcon size={17} />
            <span className="hidden md:block">{t('employee_page.create_employee')}</span>
          </div>
          <div
            className="btn btn-primary text-white hover:cursor-pointer flex items-center"
            onClick={() => setOpenInviteDialog(true)}
          >
            <MailIcon size={17} />
            <span className="hidden md:block">{t('employee_page.invite_per_email')}</span>
          </div>
        </div>
      }
    />
  );
}
